# Generated by https://pagedraw.io/pages/5249
React = require 'react'


render = ->
    React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1"})},
        React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
            @import url('https://fonts.googleapis.com/css?family=Lato:');

            * {
                box-sizing: border-box;
            }

            body {
                margin: 0;
            }

            button:hover {
                cursor: pointer;
            }

            a {
                text-decoration: none;
                color: inherit;
            }

            .pd-onhover-parent >.pd-onhover {
                display: none;
            }

            .pd-onhover-parent:hover > * {
                display: none;
            }

            .pd-onhover-parent:hover > .pd-onhover {
                display: flex;
            }

            .pd-onactive-parent > .pd-onactive {
                display: none;
            }

            .pd-onactive-parent:active > * {
                display: none;
            }

            .pd-onactive-parent:active > .pd-onactive {
                display: flex;
            }

            .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                display: none;
            }
        """)}),
        React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "paddingLeft": 15})},
            React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "paddingBottom": 1})},
                React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
                    React.createElement("a", {"href": "/", "style": ({"display": "flex"})},
                        React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1"})},
                            React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "paddingRight": 29})},
                                React.createElement("img", {"src": "https://complex-houses.surge.sh/f8b3ff29-bde2-4e98-b67e-bfa1f4cfbe04/image.png", "style": ({"width": 30, "height": 25, "flexShrink": "0", "borderWidth": 0})}),
                                React.createElement("div", {"style": ({"width": 75, "flexShrink": "0", "marginLeft": 6, "fontFamily": "\"Lato\", sans-serif", "color": (if this.props.white then 'rgba(255, 255, 255, 0.8)' else '#06122C'), "fontSize": 17, "lineHeight": "25.5px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "left", "wordWrap": "break-word"})}, """
                                    Pagedraw
""")
                            )
                        )
                    )
                )
            ),
            React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.370253164556962", "flexBasis": 0})}),
            React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column"})},
                React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
                    React.createElement("a", {"href": "/tutorials/basics", "style": ({"flexShrink": "0", "display": "flex"})},
                        React.createElement("div", {"style": ({"fontFamily": "\"Lato\", sans-serif", "color": (if this.props.white then 'rgba(255, 255, 255, 0.8)' else '#06122C'), "fontSize": 17, "lineHeight": "26px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "center", "wordWrap": "break-word", "paddingRight": 0.1875, "flexGrow": "1"})}, """
                            Get Started
""")
                    ),
                    React.createElement("a", {"href": "https://documentation.pagedraw.io/", "style": ({"flexShrink": "0", "marginLeft": 52, "display": "flex"})},
                        React.createElement("div", {"style": ({"fontFamily": "\"Lato\", sans-serif", "color": (if this.props.white then 'rgba(255, 255, 255, 0.8)' else '#06122C'), "fontSize": 17, "lineHeight": "26px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "left", "wordWrap": "break-word", "paddingRight": 0.59375, "flexGrow": "1"})}, """
                            Documentation
""")
                    ),
                    React.createElement("a", {"href": "https://medium.com/pagedraw", "style": ({"flexShrink": "0", "marginLeft": 50, "display": "flex"})},
                        React.createElement("div", {"style": ({"fontFamily": "\"Lato\", sans-serif", "color": (if this.props.white then 'rgba(255, 255, 255, 0.8)' else '#06122C'), "fontSize": 17, "lineHeight": "26px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "left", "wordWrap": "break-word", "paddingRight": 0.71875, "flexGrow": "1"})}, """
                            Blog
""")
                    ),
                    React.createElement("a", {"href": "/pricing", "style": ({"flexShrink": "0", "marginLeft": 51, "display": "flex"})},
                        React.createElement("div", {"style": ({"fontFamily": "\"Lato\", sans-serif", "color": (if this.props.white then 'rgba(255, 255, 255, 0.8)' else '#06122C'), "fontSize": 17, "lineHeight": "26px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "center", "wordWrap": "break-word", "paddingRight": 0.15625, "flexGrow": "1"})}, """
                            Pricing
""")
                    )
                )
            ),
            React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.629746835443038", "flexBasis": 0})})
        )
    )

module.exports = (props) -> render.apply({props})



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/landingtopbar.cjsx